import React, { Component } from "react";
import VisibiltySensor from "react-visibility-sensor";

export default class SuitMaterial extends Component {
	constructor(props) {
		super(props);
		this.state = { isVisible: false };
	}

	componentDidMount() {}

	componentWillUnmount() {}

	render() {
		let { isVisible } = this.state;
		var onVisibilityChange = vis => {
			if (!isVisible && vis) {
				this.setState({ isVisible: true });
			}
		};
		return (
			<div className="qs-b" ref="material">
				<div className="container block-wrap behind-mnt1">
					<div className="d-flex flex-row flex-wrap content dark">
						<div className="col-12 col-md-6">
							{this.props.children}
							{/* <div className="section-title">
								<h1 className="title">Suit Material</h1>
							</div>
							<p className="lead">
								Our 4-Way stretch fabric allows for a full range of motion with
								no limitations to your movements.
							</p>
							<p>
								The fabric is fleece backed for warmth & a fabric surface
								treatment helps dirt & moisture resistance. The perfect weight
								for outdoor warm ups.
							</p> */}
						</div>
						<div className="col-12 col-md-6">
							<VisibiltySensor
								onChange={isVisible => {
									onVisibilityChange(isVisible);
								}}>
								<div className={`material-image ${isVisible ? "inview" : ""}`}>
									<img
										src="/images/suits/material/material-layers.png"
										className="material"
									/>

									<img
										src="/images/suits/material/outlayer-text.png"
										className="text"
									/>
									<img
										src="/images/suits/material/outlayer-line.png"
										className="line"
									/>
									<img
										src="/images/suits/material/midlayer-text.png"
										className="text"
									/>
									<img
										src="/images/suits/material/midlayer-line.png"
										className="line"
									/>
									<img
										src="/images/suits/material/inlayer-text.png"
										className="text"
									/>
									<img
										src="/images/suits/material/inlayer-line.png"
										className="line"
									/>
								</div>
							</VisibiltySensor>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
